import React from "react";
import { Outlet } from "react-router";
import Header from "./header/Header";
import Menubar from "./sidebar/mobileMenubar/Menubar";

const Layout = () => {
  return (
    <div>
      <Header />
      <Menubar />
      <Outlet />
    </div>
  );
};

export default Layout;
